module.exports = __webpack_public_path__ + "static/media/small-file-icon.3e219aff.svg";